import React, { useContext } from 'react'
import { Flex, Text, getPaletteColor } from 'pcln-design-system'
import styled from 'styled-components'
import BootstrapDataContext from '@/context/BootstrapDataContext'
import TripDetailsBox from './TripDetailsBox'

export default function BookingInfo({
  product,
  date,
  headline,
  subHeadline
}: {
  product: 'hotel' | 'flight' | 'car'
  date: string
  headline: string
  subHeadline: string
}) {
  const {
    customer: { firstName = '' }
  } = useContext(BootstrapDataContext)
  const Wrapper = styled(Flex)`
    border-right: 1px solid ${getPaletteColor('border.base')};
  `

  return (
    <Wrapper
      pt={['24px', 4]}
      pb={[3, 4]}
      px={[3, '24px']}
      flexDirection="column"
      justifyContent="center"
      width={[1, null, 1 / 3, null, 3 / 11]}
    >
      <Text
        fontSize={[3, null, null, 4, 5]}
        lineHeight={[1.4, null, null, null, 1.25]}
        fontWeight="bold"
        mb={2}
        color="text.heading"
        className={firstName ? 'fs-mask' : ''}
      >
        {firstName ? `${firstName}, your` : 'Your '} trip is coming up!
      </Text>
      <Text textStyle="subheading5" color="text.light" mb="24px">
        {date}
      </Text>
      <TripDetailsBox
        product={product}
        headline={headline}
        subHeadline={subHeadline}
      />
    </Wrapper>
  )
}
